module.exports = __webpack_public_path__ + "img/AVGO.OQ.2780146d.png";